<template>
  <g class="menuIcon" transform="translate(4,2) matrix(0.3 0 0 0.3 0 0)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.89 1.54912C21.9531 0.32738 20.045 0.577991 19.4554 2.00022L12.4025 19.0125C11.8129 20.4348 12.984 21.9619 14.5105 21.7614L32.77 19.3632C34.2965 19.1627 35.0335 17.385 34.0966 16.1632L22.89 1.54912ZM32.9063 17.076L21.6997 2.46189C21.4654 2.15646 20.9884 2.21911 20.841 2.57467L13.7881 19.587C13.6407 19.9425 13.9335 20.3243 14.3151 20.2742L32.5747 17.876C32.9563 17.8259 33.1405 17.3814 32.9063 17.076Z"
      fill="#FFFEF4"
      stroke="transparent"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4367 23.2364C11.4367 26.1185 9.10038 28.4548 6.21836 28.4548C3.33634 28.4548 1 26.1185 1 23.2364C1 20.3544 3.33634 18.0181 6.21836 18.0181C9.10038 18.0181 11.4367 20.3544 11.4367 23.2364ZM9.93672 23.2364C9.93672 25.29 8.27196 26.9548 6.21836 26.9548C4.16477 26.9548 2.5 25.29 2.5 23.2364C2.5 21.1828 4.16477 19.5181 6.21836 19.5181C8.27196 19.5181 9.93672 21.1828 9.93672 23.2364Z"
      fill="#FFFEF4"
      stroke="transparent"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.8725 31.3687C25.8725 34.9712 22.9521 37.8916 19.3496 37.8916C15.7471 37.8916 12.8267 34.9712 12.8267 31.3687C12.8267 27.7661 15.7471 24.8457 19.3496 24.8457C22.9521 24.8457 25.8725 27.7661 25.8725 31.3687ZM24.3725 31.3687C24.3725 34.1427 22.1237 36.3916 19.3496 36.3916C16.5755 36.3916 14.3267 34.1427 14.3267 31.3687C14.3267 28.5946 16.5755 26.3457 19.3496 26.3457C22.1237 26.3457 24.3725 28.5946 24.3725 31.3687Z"
      fill="#FFFEF4"
      stroke="transparent"
    />
    <path
      d="M6.85693 1V6.14288H12V7.85717H6.85693V13H5.14265V7.85717H0V6.14288H5.14265V1H6.85693Z"
      fill="#FFFEF4"
      stroke="transparent"
    />
  </g>
</template>
